import { flexRender, Table } from "@tanstack/react-table";
import React from "react";
import { TableData } from "shared/ui";
import style from "./table-header.module.scss";
import { ITableColumns } from "../table";
import cx from "classnames";

interface ITableHeader {
  table: Table<TableData>;
  columns: ITableColumns[];
}

export const TableHeader = (props: ITableHeader) => {
  return (
    <thead>
      {props.table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id} className={style.table_header}>
          {headerGroup.headers.map((header, index) => (
            <th
              key={header.id}
              className={cx(
                style.header_column,
                props.columns[index].align === "left" && style.left,
                props.columns[index].align === "center" && style.center,
                props.columns[index].align === "right" && style.right
              )}
              style={{ width: `${props.columns[index].fixedWidth ? props.columns[index].fixedWidth + "px" : "auto"}` }}
            >
              {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
            </th>
          ))}
        </tr>
      ))}
    </thead>
  );
};

TableHeader.defaultProps = {};
